import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { CloseButton } from 'secondstep-components'

export const StyledCloseButton = styled(CloseButton)`
  position: relative !important;
  top: -3px !important;
  right: -1px !important;
  display: flex;
  align-self: flex-end;
  z-index: 210;
  font-weight: 400;
  padding: 0 !important;
  margin-left: 1rem;
  svg {
    height: 21px;
    width: 21px;
    color: ${themeGet('colors.blue')};

    g {
      stroke-width: 1.5;
    }
  }

  &:hover {
    svg {
      color: ${themeGet('colors.darkBlue')};
    }
  }
`

export const FlowLabel = styled.span`
  display: flex;
  align-self: flex-end;
  z-index: 0;
  font-weight: 400;
  font-size: 0.75rem;
  letter-spacing: 1.5px;
`

export const NavigationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: -0.0625rem;
  margin-bottom: -0.25rem;
`

export const LabelCloseWrapper = styled.div`
  display: flex;
  min-height: 24px;
`
